import React from 'react';
import './Products.css'; // Updated CSS file
import productImage1 from '../../../assets/exhaust_pic.png'; // Product images
import productImage2 from '../../../assets/air_handling.png';
import productImage3 from '../../../assets/hvls_png.png';

const Products = () => {
  const products = [
    { id: 1, name: "Exhaust Fans", image: productImage1 },
    { id: 2, name: "Air Cooler", image: productImage2 },
    { id: 3, name: "HVLS", image: productImage3 },
  ];

  return (
    <div className="products-section">
      <h1 className="products-title">Try Our Unique Designs</h1>
      <p className="products-description">
        At SSKV Techbuilds, we bring innovation and style to every product. Our designs are crafted to be both functional and visually striking, making your spaces not only efficient but also eye-catching. Discover the perfect blend of quality and creativity with our unique solutions.
      </p>
      <div className="products-grid">
        {products.map((product) => (
          <div key={product.id} className="product-card">
            <div className="product-image-container">
              <img src={product.image} alt={product.name} className="product-image" />
              <div className="product-overlay">
                <i className="fas fa-heart like-icon" title="Like"></i>
                <i className="fas fa-eye view-icon" title="View"></i>
              </div>
            </div>
            <h3 className="product-name">{product.name}</h3>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Products;
